import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useSaveBuild, { useSaveBuildUnsavedChanges } from '../../core/apiHooks/useSaveBuild';
import CommonModal from '../CommonModal/CommonModal';
import LeavingModalContent from './LeavingModalContent';
import { contentMaxHeightDifference } from '../CommonModal/CommonModal.styles';
import { navigateTo } from '../../utils/common';
import { removeAllTagsFromMarkdownIncludingSelfClosing } from '../../utils/markdown';
import useSummaryCard from '../BapSummaryCard/hooks/useSummaryCard';
function parseBulletListMarkup(markup) {
    var _a;
    return ((_a = markup
        .split('-')
        .filter(Boolean)
        .map(value => removeAllTagsFromMarkdownIncludingSelfClosing(value))) !== null && _a !== void 0 ? _a : []);
}
const LeavingModal = ({ closeModal, showModal, nextUrl }) => {
    var _a;
    const { t } = useTranslation();
    const bulletList = parseBulletListMarkup(t('Pages.Bap.leavingSoonBulletText'));
    const { nameBadge, vehicle, modelImage, bigExteriorImage } = useSummaryCard();
    const buildName = `${vehicle.modelYear} ${vehicle.modelName} - ${vehicle.trimName} ${(_a = vehicle.transmission) === null || _a === void 0 ? void 0 : _a.transmissionName}`;
    const { saveBuild, updateBuild, isProcessing } = useSaveBuild(buildName);
    const { hasUnsavedChanges } = useSaveBuildUnsavedChanges();
    const navigateToNextUrl = () => {
        LeavingModal.navigateTo(nextUrl);
        closeModal();
    };
    const handleSubmit = () => {
        if (hasUnsavedChanges)
            return updateBuild({
                onSuccess: navigateToNextUrl,
                onError: navigateToNextUrl,
            });
        saveBuild({
            onSuccess({ redirectUrl, isUserLoggedIn }) {
                if (isUserLoggedIn)
                    return navigateToNextUrl();
                LeavingModal.navigateTo(redirectUrl);
                closeModal();
            },
            onError: navigateToNextUrl,
        });
    };
    return (_jsx(CommonModal, { handleCloseModal: navigateToNextUrl, handleSubmit: handleSubmit, showModal: showModal, submitButtonEnabled: !isProcessing, handleCrossIconClick: closeModal, dataTestId: "cy-LeavingModal", primaryButtonText: t('Pages.Bap.saveButton'), secondaryButtonText: t('Pages.Bap.doNotSaveButton'), title: t('Pages.Bap.leavingSoonModalHeading'), childrenProps: {
            otherStyles: {
                maxHeight: contentMaxHeightDifference.map(value => `calc(100vh - ${value})`),
                overflowY: 'auto',
            },
        }, children: _jsx(LeavingModalContent, { vehicleImage: modelImage, modelBadgeImage: nameBadge, vehicle, buildName, bigExteriorImage, description: t('Pages.Bap.leavingSoonLine1Text'), bulletListHeader: t('Pages.Bap.leavingSoonLine2Text'), bulletList: bulletList }) }));
};
export default LeavingModal;
LeavingModal.navigateTo = navigateTo;
